import { render, staticRenderFns } from "./IframeDrawer.vue?vue&type=template&id=640b0c93&scoped=true&"
import script from "./IframeDrawer.vue?vue&type=script&lang=js&"
export * from "./IframeDrawer.vue?vue&type=script&lang=js&"
import style0 from "./IframeDrawer.vue?vue&type=style&index=0&id=640b0c93&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640b0c93",
  null
  
)

export default component.exports